// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { openBidsDetailsTotalStyles } from "@steiner/App/Widgets/OpenBidsDetails/OpenBidsDetailsTotal";
import { color, mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

openBidsDetailsTotalStyles.wrapper = {
    ...orderTotalDisplaySharedStyles.wrapper,
};

openBidsDetailsTotalStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};

openBidsDetailsTotalStyles.fullWidthGridItem = {
    width: 12,
};

openBidsDetailsTotalStyles.subtotalLabelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

openBidsDetailsTotalStyles.subtotalValueGridItem = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.valueGridItem, {
        css: css`
            flex-direction: column;
            align-items: end;
        `,
    }),
};

openBidsDetailsTotalStyles.titleText = {
    ...orderTotalDisplaySharedStyles.titleText,
};

openBidsDetailsTotalStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

openBidsDetailsTotalStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

openBidsDetailsTotalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};

openBidsDetailsTotalStyles.boxContainer = {
    css: css`
        background-color: ${color("common.ui14")};
    `,
};